import React, { createContext, useContext, useState } from 'react';

const VersionContext = createContext();

export const useVersion = () => {
  const context = useContext(VersionContext);
  if (!context) {
    throw new Error('useVersion must be used within a VersionProvider');
  }
  return context;
};

export const VersionProvider = ({ children }) => {
  const [showV2, setShowV2] = useState(true); // Default to V2

  return (
    <VersionContext.Provider value={{ showV2, setShowV2 }}>
      {children}
    </VersionContext.Provider>
  );
};
